// Generate a unique transaction ID for errors
const transactionId = Math.random().toString(36).substr(2, 9);

export function getTransactionId(): string {
  return transactionId;
}
